import React from 'react';

import BaseOAuthButton from './BaseOAuthButton';

import Icon from '../assets/sso.svg';
import { BaseOAuthProps } from '../types';

const EnterpriseOAuthButton: React.FC<BaseOAuthProps> = (props) => {
    return <BaseOAuthButton {...props} label="Enterprise sign-in" apiUrl={null} icon={<Icon />} />;
};

export default EnterpriseOAuthButton;
